import { useState, useEffect } from 'react';
import { makeLayoutsData, widgetDiscriminator } from './index';
import { useSelector } from 'react-redux';

const useWidgetGenerator = widgetInfo => {
    const { mode } = useSelector(state => state.ScreenInfo);
    const [layouts, setLayouts] = useState({});
    const [Widgets, setWidgets] = useState(null);

    useEffect(() => {
        if (Array.isArray(widgetInfo)) {
            const layout = widgetInfo.map(info => {
                // console.log(info);
                return info.layout;
            });
            setLayouts(makeLayoutsData(layout, mode));
            setWidgets(widgetInfo.map(info => widgetDiscriminator(info)));
        } else {
            setLayouts({});
            setWidgets(null);
        }
    }, [widgetInfo]);

    return { layouts, Widgets };
};

export default useWidgetGenerator;
